<template>
    <div>
        <CustomTable
            :items.sync="componentItems"
            :fields="componentFields"
            :resizable="resizable"
            :columnFilterValue="columnFilterValue"
            :size="size"
            :items-per-page-select="itemsPerPageSelect"
            :items-per-page="itemsPerPage"
            :responsive="responsive"
            :sorter="sorter"
            :loading="componentLoading"
            :sorterValue="sorterValue"
            @update:column-filter-value="emitUpdateColumnFilterValue"
            @update:sorter-value="emitUpdateSorterValue"
            @pagination-change="emitPaginationChange"
        >
            <template #over-table>
                <slot name="over-table"></slot>
            </template>
            <template #under-table>
                <slot name="under-table"></slot>
            </template>
            <template #no-items-view>
                <slot name="no-items-view"></slot>
            </template>
            <template #details="{ index, item }">
                <slot name="details" v-bind="{ item, index }"></slot>
            </template>
            <template
                v-for="field in componentListFieldsActive"
                v-slot:[field]="{ item, index }"
            >
                <slot :name="field" v-bind="{ item, index }"></slot>
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import CustomTable from "~/components/CustomTable";

/** Mixins */
import ComponentTable from "~/mixins/ComponentTable";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";
import MappingFormatType from "~/assets/options/mapping_format_type.json";
import DateFormat from "~/assets/options/date_format.json";

const FilterOptions = {
    contains: "like",
    not_contains: "not_like",
    is_equal_to: "equal",
    is_not_equal_to: "not_equal",
    is_in_list: "regexp",
    not_in_list: "not_regexp",
};

export default {
    name: "CCTable",
    mixins: [traslateMixin, ComponentTable],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
        MappingFormatType,
        DateFormat,
    },
    components: {
        CustomTable,
    },
    data() {
        return {
            componentItems: [],
            componentFields: [],
            componentLoading: false,
            componentColumnFilterValue: null,
        };
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        fields: {
            default: () => {
                return [];
            },
        },
        responsive: {
            default: true,
        },
        loading: {
            default: false,
        },
        size: {
            default: "md",
        },
        columnFilterValue: {
            default: null,
        },

        itemsPerPageSelect: {
            type: Object | Boolean,
            default: false,
        },
        itemsPerPage: {
            type: Object | Number,
            default: 5,
        },
        sorter: {
            default: false,
        },
        sorterValue: {
            default: () => {
                return {
                    column: null,
                    asc: true,
                };
            },
        },
        resizable: {
            default: true,
        },
        loadQueryFromUrl: {
            default: false,
        },
    },
    watch: {
        items: {
            async handler(newValue) {
                this.componentItems = this.items;
            },
            deep: true,
        },
        fields(newValue) {
            this.componentFields = newValue;
        },
        loading(newValue) {
            this.componentLoading = newValue;
        },
        componentLoading(newValue) {
            this.$emit("update:loading", newValue);
        },
    },
    methods: {
        getFilterOptionKeyByValue(condition) {
            for (const key in FilterOptions) {
                const value = FilterOptions[key];
                if (value === condition) {
                    return key;
                }
            }
            return null;
        },

        emitPaginationChange(newValue) {
            this.$emit("pagination-change", newValue);
        },
        emitUpdateSorterValue(newValue) {
            this.$emit("update:sorterValue", newValue);
            this.$emit("update:sorter-value", newValue);
        },
        emitUpdateColumnFilterValue(newValue) {
            this.$emit("update:columnFilterValue", newValue);
            this.$emit("update:column-filter-value", newValue);
        },
        loadUrlQuery() {
            const urlParams = new URLSearchParams(window.location.search);
            const query = urlParams.get("query");
            let queryDecode = {};
            if (query) {
                queryDecode = JSON.parse(query);
                const whereQuery = queryDecode.where;
                for (const whereField in whereQuery) {
                    const condition = Object.keys(whereQuery[whereField])[0];
                    const value = whereQuery[whereField][condition];
                    const findFieldTable = this.componentFields.find(
                        (field) => field.key === whereField
                    );
                    if (findFieldTable) {
                        findFieldTable._filter = {
                            active: false,
                            condition: null,
                            value: null,
                        };
                        findFieldTable._filter.active = true;
                        findFieldTable._filter.condition =
                            this.getFilterOptionKeyByValue(condition);
                        findFieldTable._filter.value = value;
                    }
                }

                this.$emit("update:fields", this.componentFields);
            }
        },
    },
    mounted() {
        this.componentFields = this.fields;
        this.componentItems = this.items;
        this.componentColumnFilterValue = this.columnFilterValue;
        this.componentLoading = this.loading;
        if (this.loadQueryFromUrl === true) {
            this.loadUrlQuery();
        }
    },
};
</script>

<style></style>
